import React from 'react';
import { BiInfoCircle } from 'react-icons/bi';

import ChampDeTexte from '../../UI/ChampDeTexte/ChampDeTexte';
import CaseACocher from '../../UI/CaseACocher/CaseACocher';
import ListeDeroulante from '../../UI/ListeDeroulante/ListeDeroulante';

import S from './FileInput.module.scss';

const FileInput = ({ argument, onChange }) => {
  const handleOptionChange = (field, value) => {
    const newOptions = {
      ...argument.options,
      [field]: value,
    };
    onChange('options', newOptions);
  };

  const fileTypes = [
    { value: 'any', label: 'Tous les fichiers' },
    { value: 'image', label: 'Images (jpg, png, gif, etc.)' },
    { value: 'document', label: 'Documents (pdf, doc, txt, etc.)' },
    { value: 'data', label: 'Données (csv, xlsx, json, etc.)' },
    { value: 'custom', label: 'Types personnalisés' },
  ];

  return (
    <div className={S.fileContainer}>
      <div className={S.infoBox}>
        <BiInfoCircle size={16} />
        <span>
          Ce type d'argument permet de télécharger et sélectionner des fichiers.
        </span>
      </div>

      <div className={S.configSection}>
        <h6 className={S.configTitle}>Configuration</h6>

        <div className={S.champGroupe}>
          <label className={S.label}>Description</label>
          <ChampDeTexte
            valeur={argument.description || ''}
            changement={(e) => onChange('description', e.target.value)}
            placeholder="Description de l'argument"
            multiline={true}
            rows={2}
          />
        </div>

        <div className={S.checkboxGroup}>
          <CaseACocher
            checked={argument.obligatoire || false}
            changement={(checked) => onChange('obligatoire', checked)}
            label="Fichier obligatoire"
          />
        </div>
      </div>

      <div className={S.configSection}>
        <h6 className={S.configTitle}>Options spécifiques</h6>

        <div className={S.champGroupe}>
          <label className={S.label}>Type de fichiers acceptés</label>
          <ListeDeroulante
            valeur={argument.options?.fileType || 'any'}
            changement={(value) => handleOptionChange('fileType', value)}
            options={fileTypes}
          />
        </div>

        {argument.options?.fileType === 'custom' && (
          <div className={S.champGroupe}>
            <label className={S.label}>
              Extensions personnalisées (séparées par des virgules)
            </label>
            <ChampDeTexte
              valeur={argument.options?.customExtensions || ''}
              changement={(e) =>
                handleOptionChange('customExtensions', e.target.value)
              }
              placeholder="pdf,doc,docx,txt"
            />
          </div>
        )}

        <div className={S.champGroupe}>
          <label className={S.label}>Taille maximum (MB)</label>
          <ChampDeTexte
            type="number"
            valeur={argument.options?.maxSize || ''}
            changement={(e) =>
              handleOptionChange('maxSize', parseInt(e.target.value) || null)
            }
            placeholder="10"
            min="1"
          />
        </div>

        <div className={S.checkboxGroup}>
          <CaseACocher
            checked={argument.options?.permitMultiple || false}
            changement={(checked) =>
              handleOptionChange('permitMultiple', checked)
            }
            label="Permettre la sélection de plusieurs fichiers"
          />
        </div>
      </div>

      <div className={S.previewSection}>
        <h6 className={S.configTitle}>Aperçu de l'input utilisateur</h6>
        <div className={S.previewBox}>
          <div className={S.mockInput}>
            <div className={S.mockLabel}>
              {argument.nom || "Nom de l'argument"}
              {argument.obligatoire && <span className={S.required}>*</span>}
            </div>
            <div className={S.mockField}>
              Sélection de fichier{argument.options?.permitMultiple ? 's' : ''}
              {argument.options?.maxSize &&
                ` (Max: ${argument.options.maxSize}MB)`}
            </div>
            {argument.description && (
              <div className={S.mockDescription}>{argument.description}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileInput;
